import React from 'react';
import { withPrefix, Link } from 'gatsby';
import ReactMarkdown from 'react-markdown';


const VideoBlock = (props) => {
  return (
      
    <section className="videoblock">

        <div className="container">
            <div className="columns">
                <div className="video column is-two-thirds">
                    <div className="card">
                        <div className="card-image">
                            <figure className="image is-16by9">
                                <iframe width="100%" height="100%" src={ props.locale === "en" ? "https://www.youtube.com/embed/kRKXzptLEM0" : "https://www.youtube.com/embed/6ySR9dMU81I" } frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </figure>
                        </div>
                    </div>
                </div>

                <div className="column">
                    <div className="headliner">
                        <ReactMarkdown source={ props.videoblock.videoblockHeadline } />
                        <p>
                            { props.videoblock.videoblockHeadlineSubtext }
                        </p>
                    </div>
                </div>
                
            </div>
        </div>  
    </section>
  );
};

export default VideoBlock;
